import * as Yup from "yup"
import keycode from "keycode"
import { FirstKeys, ReservedCombinations } from "./HotKeysExtensionForm.const"
import { TFunction } from "i18next"

export const tErrorNamespace = "error:fastReplies.hot-keys."

const getReservedByFirstKey = (firstKey: string): number[] =>
    ReservedCombinations.find(reserved => reserved.firstKey === keycode(firstKey))?.secondKeys || []

export const getHotKeysValidationSchema = (t: TFunction) =>
    Yup.object().shape({
        FirstKey: Yup.string().required(`${tErrorNamespace}required`),
        SecondKey: Yup.string()
            .max(1, `${tErrorNamespace}maxOneCharacter`)
            .required(`${tErrorNamespace}required`)
            .test("oneOfReserved", `${tErrorNamespace}reserved`, function (value) {
                return !getReservedByFirstKey(this.parent.FirstKey).includes(keycode(value || ""))
            })
            .test("invalidCombination", `${tErrorNamespace}invalidCombination`, function (value) {
                return Number(keycode(this.parent.FirstKey)) === FirstKeys.SHIFT && value
                    ? !/[\wа-я]/gi.test(value)
                    : true
            })
    })
